//replaces piechart.html
//replaces piechart-mobileweb.html
import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { NgToReactChart } from "app/components/React/NgToReactChart/NgToReactChart";
import { i18nFilter } from "app/filters/i18nFilter";
import { deviceTrafficShareFilter } from "app/filters/ngFilters";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export const PieChartTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    return (
        <>
            {!widget.viewOptions.isMobileOrDesktopOnly || widget.apiParams.webSource === "Total" ? (
                <div className={`chartContainer ${widget.viewOptions.cssClass}`}>
                    <NgToReactChart highchartsNgConfig={widget.chartConfig} />
                </div>
            ) : null}
            {/*piechart-mobileweb.html*/}
            {widget.data && widget.viewOptions.isMobileOrDesktopOnly ? (
                <>
                    {widget.isMobileWebCountry ? (
                        <>
                            <div className="u-alignCenter">
                                {widget.apiParams.webSource === "Desktop" ? (
                                    <div className="single-metric-device-share">
                                        <SWReactIcons
                                            iconName="desktop"
                                            size="xxl"
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <div className="single-metric-device-share-share-value">
                                <div className="big-text u-blueMediumMedium">
                                    {deviceTrafficShareFilter()(widget.data, "Desktop")}
                                </div>
                                <div className="u-font14 u-alignLeft single-metric-device-share-text">
                                    Of all traffic
                                </div>
                            </div>
                        </>
                    ) : null}
                    {widget.apiParams.webSource === "MobileWeb" ? (
                        <div className="single-metric-device-share">
                            <i className="sw-icon-phone-data single-metric-device-share-icon"></i>
                            <div className="single-metric-device-share-share-value">
                                <div className="big-text u-blueMediumMedium">
                                    {deviceTrafficShareFilter()(widget.data, "Mobile Web")}
                                </div>
                                <div className="u-font14 u-alignLeft single-metric-device-share-text">
                                    Of all traffic
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {!widget.isMobileWebCountry ? (
                        <div
                            className="u-alignCenter"
                            style={{ marginTop: 30 }}
                        >
                            {widget.apiParams.webSource === "Desktop" ? (
                                <div className="pie-mobile-or-web-only">
                                    <SWReactIcons
                                        iconName="desktop"
                                        size="xxl"
                                    />
                                    <div className="text-padding">
                                        <div className="font-26">{i18nFilter()("wa.ao.pie.desktop")}</div>
                                        <div className="font-16 u-alignLeft">{i18nFilter()("wa.ao.pie.dataonly")}</div>
                                    </div>
                                </div>
                            ) : null}
                            {widget.apiParams.webSource === "MobileWeb" ? (
                                <div className="pie-mobile-or-web-only">
                                    <i className="sw-icon-phone-data"></i>
                                    <div className="text-padding">
                                        <div className="font-26">{i18nFilter()("wa.ao.pie.mobileweb")}</div>
                                        <div className="font-16 u-alignLeft">{i18nFilter()("wa.ao.pie.dataonly")}</div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </>
            ) : null}
        </>
    );
};
